// extracted by mini-css-extract-plugin
export default {"root":"login_root__cSTSp","wrapper":"login_wrapper__ADayY","loginWarning":"login_loginWarning__jNKHv","loginBox":"login_loginBox__HYQHv","googleButton":"login_googleButton__MBd+l"};